<template>
  <div>
    <v-container fluid grid-list-xs >
      <v-layout row wrap>
        <v-flex xs12>
          <address-list :direcciones="addresses"></address-list>
        </v-flex>
      </v-layout>
    </v-container>

    <v-tooltip left>
      <v-btn fab fixed bottom right dark slot="activator" color="primary" @click="crear">
        <v-icon dark class="pt-3">add</v-icon>
      </v-btn>
      <span>{{$t('domicilios.nuevoDomicilio')}}</span>
    </v-tooltip>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import AddressList from "@/components/addresses/AddressListV2";
//import AddressCreate from './AddressCreate'
export default {
  components: {
    AddressList
  },
  name: "direcciones",
  mounted() {
    this.fetchAddresses(this.filtro);
  },
  data() {
    return {
      Firefox: (typeof InstallTrigger !== 'undefined')||(window.StyleMedia)
    };
  },
  methods: {
    crear() {
      this.$router.push("/direcciones/create");
    },
    ...mapActions("addresses", ["fetchAddresses"])
  },
  computed: {
    ...mapGetters("addresses", ["addresses", "defecto"]),
    ...mapState("addresses", ["filtro"])
  }
};
</script>
